import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

import {PricingTableCellSchema} from './pricing-table-cell'

const COMPONENT_ID = 'pricingTableRow'
export const COLUMN_COUNT = 3

export const PricingTableRowSchema = buildEntrySchemaFor(COMPONENT_ID, {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      description: RichTextSchema,
      content: z.array(z.lazy(() => PricingTableCellSchema)).length(COLUMN_COUNT),
    }),
  ),
})

export type PricingTableRow = z.infer<typeof PricingTableRowSchema>
